function bipCountdown() {
  const bipCountdownSection = document.getElementById("bip-countdown");

  if (bipCountdownSection !== null) {

    // Set the date we're counting down to
    const bipCountdownDate = new Date("May 16, 2024 08:00:00").getTime();
    const bipCountdownDays = document.querySelector("#bip-countdown .ef-countdown__unit--days .ef-countdown__digits");
    const bipCountdownHours = document.querySelector("#bip-countdown .ef-countdown__unit--hours .ef-countdown__digits");
    const bipCountdownMinutes = document.querySelector("#bip-countdown .ef-countdown__unit--minutes .ef-countdown__digits");
    const bipCountdownSeconds = document.querySelector("#bip-countdown .ef-countdown__unit--seconds .ef-countdown__digits");

    // Update the count down every 1 second
    let bipCountdown = setInterval(() => {

      // Get today's date and time
      let now = new Date().getTime();
        
      // Find the distance between now and the countdown date
      let distance = bipCountdownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
      // Output the result
      bipCountdownDays.innerHTML = days;
      bipCountdownHours.innerHTML = hours;
      bipCountdownMinutes.innerHTML = minutes;
      bipCountdownSeconds.innerHTML = seconds;
        
      // If the countdown is over, hide it
      if (distance < 0) {
        clearInterval(bipCountdown);
        bipCountdownSection.style.display = "none";
      }
    }, 1000);
  }
}

if (document.readyState !== "loading") {
  bipCountdown();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    bipCountdown();
  });
}

function demoCountdown() {
  const demoCountdownSection = document.getElementById("demo-countdown");

  if (demoCountdownSection !== null) {

    // Set the date we're counting down to
    const demoCountdownDate = new Date("Jan 1, 2025 00:00:00").getTime();
    const demoCountdownDays = document.querySelector("#demo-countdown .ef-countdown__unit--days .ef-countdown__digits");
    const demoCountdownHours = document.querySelector("#demo-countdown .ef-countdown__unit--hours .ef-countdown__digits");
    const demoCountdownMinutes = document.querySelector("#demo-countdown .ef-countdown__unit--minutes .ef-countdown__digits");
    const demoCountdownSeconds = document.querySelector("#demo-countdown .ef-countdown__unit--seconds .ef-countdown__digits");

    // Update the count down every 1 second
    let demoCountdown = setInterval(() => {

      // Get today's date and time
      let now = new Date().getTime();
        
      // Find the distance between now and the countdown date
      let distance = demoCountdownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
      // Output the result
      demoCountdownDays.innerHTML = days;
      demoCountdownHours.innerHTML = hours;
      demoCountdownMinutes.innerHTML = minutes;
      demoCountdownSeconds.innerHTML = seconds;
        
      // If the countdown is over, hide it
      if (distance < 0) {
        clearInterval(bipCountdown);
        demoCountdownSection.style.display = "none";
      }
    }, 1000);
  }
}

demoCountdown();
